module.exports = __webpack_public_path__ + "img/Square_4.e2b8174e.jpg";